import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

export default class Form {
  rules: string[] = [
    "IsCNPJ",
    "IsCPF",
    "IsCPForCNPJ",
    "Exists",
    "NotExists",
    "isString",
    "isEmail",
    "isNotEmpty",
    "isArray",
    "IsUuid",
    "isDate",
    "MinLength",
    "MaxLength",
    "isDateString",
    "isEnum",
    "Matches"
  ];

  form: FormGroup;

  subForms = [];

  getForm(name: string): FormGroup {
    const form = this[name];

    if (!(form instanceof FormGroup)) throw new Error(`Form ${name} is not a FormGroup`);

    return form;
  }

  field(field: string, fieldArray?: FormControl): FormControl {
    let form = this.form;
    const fieldSplit = field.split(".");
    if (fieldSplit.length > 1 && this.isSubForm(fieldSplit[0])) {
      form = this.getForm(fieldSplit[0]);
      fieldSplit.shift();
      field = fieldSplit.join(".");
    }

    if (fieldArray) {
      return fieldArray.get(field) as FormControl;
    }

    return form.get(field) as FormControl;
  }

  hasError(field: string): boolean;
  hasError(field: string, error?: string): boolean;
  hasError(field: string, error?: string, fieldArray?: any): boolean;
  hasError(field: string, error?: string, fieldArray?: any): boolean {
    const fieldControl = this.field(field, fieldArray);

    if (!fieldControl) return false;

    if (!error) {
      return !fieldControl.valid && (fieldControl.touched || fieldControl.dirty);
    }

    const errorSplit = error.split("|");

    if (errorSplit.length > 1) {
      return errorSplit.some(error => fieldControl.hasError(error));
    }

    return fieldControl.hasError(error);
  }

  hasErrorMultiple(fields: string[] | string): boolean {
    if (typeof fields === "string") {
      fields = [fields];
    }

    for (const field of fields) {
      if (this.hasError(field)) {
        return true;
      }
    }

    return false;
  }

  cssError(field: string);
  cssError(...fields: string[]);
  cssError(...fields: string[]) {
    if (fields.length > 1) {
      return {
        "is-invalid": this.hasErrorMultiple(fields)
      };
    }

    return {
      "is-invalid": this.hasError(fields[0])
    };
  }

  applyErrors(errors: any, formName = "form") {
    for (const field in errors) {
      const error = errors[field];
      Object.keys(error).map(key => {
        const fieldName = formName === "form" ? field : `${formName}.${field}`;

        if (!this.rules.find(rule => rule === key)) {
          const name = `${fieldName}.${key}`;

          if (!this.field(name)) return;
          this.field(name).setErrors(error[key]);
          return;
        }

        this.field(fieldName).setErrors(error);
      });
    }

    for (const formName of ["form", ...this.subForms]) {
      const form = this.getForm(formName);
      form.markAllAsTouched();
    }
  }

  private isSubForm(name: string): boolean {
    return this.subForms.includes(name);
  }
}
